export const MEDICATIONS_REDUCER_STATE_ID = 'medications';
